import React from "react";

export default function Input({
  type = "email",
  placeholder = "",
  value = "",
  onChange,
  onKeyDown,
  maxLength,
  disabled = false,
  className = "h-14 ml-1 mr-1 rounded-full border-0 text-sm !px-5 mb-3 w-full border-none outline-none bg-[#DFE8F0] placeholder-[#6C94B4]",
}) {
  return (
    <input
      placeholder={placeholder}
      className={className}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      type={type}
      disabled={disabled}
      maxLength={maxLength}
      onWheel={(e) => e.target.blur()}
    />
  );
}
